// extracted by mini-css-extract-plugin
export default {"wrapper":"MondoChart_wrapper__rYkzf","contentCard":"MondoChart_contentCard__y9Hmi"};